import * as React from "react";
function XlIcon() {
    return React.createElement("path", { d: "M9.16699 21.047V18.9531H30.8336V21.047H9.16699Z", fill: "currentColor" });
}
export default XlIcon;
//# sourceMappingURL=Xl.js.map